import { Food, PaginatedResource, Tag } from '@/types';
import { ApiService } from '@/services/ApiService';

export class SearchService extends ApiService {
    public searchFood(query: string): Promise<PaginatedResource<Food>> {
        return this.fetch(route('api.search.food', { q: query }));
    }

    public listFood(ids: string[]): Promise<PaginatedResource<Food>> {
        return this.fetch(route('api.search.food', { ids: ids }));
    }

    public searchTags(query: string): Promise<PaginatedResource<Tag>> {
        return this.fetch(route('api.search.tags', { q: query }));
    }

    public listTags(ids: string[]): Promise<PaginatedResource<Tag>> {
        return this.fetch(route('api.search.tags', { ids: ids }));
    }
}
